import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {FormGroup, AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { PopulationGroupComponent } from "../../population-group.component";

import { UserAccountApi, PopulationCategoryApi, SectorApi } from '../../../../../../theme/services/sdk';
import { BaToastNotificationService } from '../../../../../../theme/services/baToastNotification'

@Component({
  selector: 'population-group-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  providers:[UserAccountApi,PopulationCategoryApi,SectorApi,BaToastNotificationService]
})
export class PopulationGroupForm{

  public form:FormGroup;
  public name:AbstractControl;
  public description:AbstractControl;
  public sector_id:AbstractControl;
  public sort_order:AbstractControl;
  public submitted:boolean = false;

  sector_list:Object;
  population_group:Object;

  constructor(fb:FormBuilder, protected user:UserAccountApi, protected populationCategory:PopulationCategoryApi, protected sector:SectorApi, private route: ActivatedRoute, private router: Router,private toast: BaToastNotificationService, private data: PopulationGroupComponent) {
    this.form = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'description': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'sector_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      'sort_order': ['', Validators.compose([Validators.required, Validators.minLength(1)])]
    });

    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
    this.sector_id = this.form.controls['sector_id'];
    this.sort_order = this.form.controls['sort_order'];
    this.user.isAuthenticated()?false:this.router.navigate(['login']);
  }

  ngOnInit() {
    this.sector.find().subscribe((res)=>{
      this.sector_list = res;
    })
    this.data.population_group.subscribe(data=>this.population_group=data);
  }

  public onSubmit(values:Object):void {
    this.submitted = true;
    if (this.form.valid) {
      let self = this;
      let pg;

      if(this.population_group['id']){
        pg = this.populationCategory.upsert({
          id: this.population_group['id'],
          name: self.name['value'],
          description: self.description['value'],
          sector_id: self.sector_id['value'],
          sort_order: self.sort_order['value'],
        })
      }else{
        pg = this.populationCategory.create({
          name: self.name['value'],
          description: self.description['value'],
          sector_id: self.sector_id['value'],
          sort_order: self.sort_order['value'],
        })
      }

      pg.subscribe(res => {
        let msg: string;
        this.data.refresh();
        this.form.reset();
        if(this.population_group['id']){
          this.data.cancelSelected();
          msg = 'Record updated';
        }else{
          msg = 'New population group added';
        }
        this.toast.success({
          heading: 'Success',
          text: msg,
          stack: 3
        });
      }, err=>{
        this.toast.error({
          heading: err.name,
          text: err.message,
          stack: 3
        });
        console.log(err);
      });
    }
  }

  cancelSelected(){
    this.data.cancelSelected();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/population-group/components/form/form.component.ts